// Fallback columns for the Phonics / Movable Alphabets / Cursive progress
// screens. Used only when a school has no master records and no student has any
// progress saved yet, so the grid (and its P / WA / WI / M buttons) still shows.

export const DEFAULT_SOUNDS = [
  "SPL", "a", "i", "o", "u", "e", "m", "n", "r", "s", "l", "f", "h", "v", "y",
  "z", "w", "k", "t", "p", "b", "d", "g", "j", "c", "x", "q",
];

export const DEFAULT_MOVABLES = [
  "Vowel-1", "Vowel-2", "Vowel-3", "j", "e", "sh", "ch", "th", "ng", "oo", "ee",
  "a-e", "i-e", "o-e", "u-e (1)", "u-e (2)", "le", "qu", "ssggll",
  "Hp -vowel", "Hp-Const", "Hg-Vowel", "Hg-Const",
];

export const DEFAULT_CURSIVES = "abcdefghijklmnopqrstuvwxyz".split("");
